const StatusesLightValues = Object.freeze({
    error: {
        base: {
            default: '#D31E2A',
            action: '#9D0007',
            active: '#D31E2A',
            activeAction: '#9D0007',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    warning: {
        base: {
            default: '#FE9D24',
            action: '#C9760E',
            active: '#FE9D24',
            activeAction: '#C9760E',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    success: {
        base: {
            default: '#158423',
            action: '#0E5A18',
            active: '#158423',
            activeAction: '#0E5A18',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    information: {
        base: {
            default: '#5A00EE',
            action: '#3D00A2',
            active: '#5A00EE',
            activeAction: '#3D00A2',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    positive: {
        base: {
            default: '#ffffff',
            action: '#B4B4B4',
            active: '#ffffff',
            activeAction: '#B4B4B4',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    negative: {
        base: {
            default: '#000000',
            action: '#787878',
            active: '#000000',
            activeAction: '#787878',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    highLight: {
        base: {
            default: '#00C5C3',
            action: '#008685',
            active: '#00C5C3',
            activeAction: '#008685',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    disabled: 0.32,
});
const StatusesDarkValues = Object.freeze({
    error: {
        base: {
            default: '#F8495A',
            action: '#A62332',
            active: '#F8495A',
            activeAction: '#A62332',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    warning: {
        base: {
            default: '#FFC13C',
            action: '#D69200',
            active: '#FFC13C',
            activeAction: '#D69200',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    success: {
        base: {
            default: '#64ED68',
            action: '#45A349',
            active: '#64ED68',
            activeAction: '#45A349',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    information: {
        base: {
            default: '#BD99F8',
            action: '#8168A9',
            active: '#BD99F8',
            activeAction: '#8168A9',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    positive: {
        base: {
            default: '#000000',
            action: '#787878',
            active: '#000000',
            activeAction: '#787878',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
    negative: {
        base: {
            default: '#ffffff',
            action: '#B4B4B4',
            active: '#ffffff',
            activeAction: '#B4B4B4',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    highLight: {
        base: {
            default: '#72FFEA',
            action: '#4EAD9F',
            active: '#72FFEA',
            activeAction: '#4EAD9F',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    disabled: 0.32,
});

export { StatusesDarkValues, StatusesLightValues };
